import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ConnectedRouter, push } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import { history } from './store/configureStore';
import * as types from './../lib/constants';
import './../lib/styles/fonts.css';
import ConfigManager from './../lib/common/configManager/configManager';
//import TeamPage from './../lib/containers/TeamPage';
import TeamMainHeader from '../lib/containers/TeamMainHeader';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    const { sportId, competitionId, teamId } = window.matchcenterPage;
    this.props.actions.getHeaderInfo(sportId, competitionId, teamId);
  }

  render() {
    const {
      actions, dictionary,
      //statistics, squad, clubInfo,
      headerInfo,
    } = this.props;
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route
            path={ConfigManager.getRoute('teamPage')}
            render={() => (
              <TeamMainHeader
                actions={actions}
                dictionary={dictionary}
                headerInfo={headerInfo}
              />
            )}
          />
        </Switch>
      </ConnectedRouter>
    );
  }
}

App.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  /*statistics: PropTypes.any,
  squad: PropTypes.any,
  clubInfo: PropTypes.any,*/
  headerInfo: PropTypes.any,
};

export default connect(
  state => ({
    location: state.router.location,
    dictionary: state.dictionaryReducer.dictionary,
    statistics: state.statisticsReducer,
    squad: state.squadReducer.squad,
    clubInfo: state.clubInfoReducer.clubInfo,
    headerInfo: state.headerInfoReducer.headerInfo,
  }),
  dispatch => ({
    actions: {
      push: url => dispatch(push(url)),
      updateLocalStorage: () =>
        dispatch({ type: types.UPDATE_LOCAL_STORAGE }),
      getStandings: (sportId, competitionId, teamId) =>
        dispatch({
          type: types.GET_STANDINGS_REQUEST,
          sportId,
          competitionId,
          teamId,
        }),
      getLastMatches: (sportId, teamId, competitionId) =>
        dispatch({
          type: types.GET_LAST_MATCHES_REQUEST,
          sportId,
          teamId,
          competitionId,
        }),
      getSquad: (sportId, competitionId, teamId) =>
        dispatch({
          type: types.GET_SQUAD_REQUEST,
          sportId,
          competitionId,
          teamId,
        }),
      getClubInfo: (teamId, sportId) =>
        dispatch({ type: types.GET_CLUB_INFO_REQUEST, sportId, teamId }),
      getHeaderInfo: (sportId, competitionId, teamId) =>
        dispatch({
          type: types.GET_HEADER_INFO_REQUEST,
          sportId,
          teamId,
          competitionId,
        }),
    },
  }),
)(App);



// WEBPACK FOOTER //
// ./src/demo/AppHeader.js